export default __webpack_public_path__ + "static/future-perfect-f897bd0a6e75129286828012bddf47ea.svg";